export const getInviteErrorMessageFromCognitoError = (
  errorMessage?: string
) => {
  if (!errorMessage || errorMessage.includes('User does not exist'))
    return 'We could not sign you in.';

  if (errorMessage.includes('expired')) {
    return 'Invitation expired. Ask your admin to resend it.';
  }

  return errorMessage;
};
